import React from "react";
import { useLocation } from "react-router-dom";

import queryString from "query-string";

import ResultsPageView from "./results-page-view";

export default () => {
  const location = useLocation();
  const params = queryString.parse(location.search);

  const age = "age" in params && params.age ? parseInt(params.age) : 21;
  const startingCapital =
    "startingCapital" in params && params.startingCapital
      ? parseFloat(params.startingCapital)
      : 10_000;
  const monthlyDeposit =
    "monthlyDeposit" in params && params.monthlyDeposit
      ? parseFloat(params.monthlyDeposit)
      : 0;
  const riskToleranceMod =
    "riskToleranceMod" in params && params.riskToleranceMod
      ? parseFloat(params.riskToleranceMod)
      : 0;

  return (
    <ResultsPageView
      age={age}
      startingCapital={startingCapital}
      monthlyDeposit={monthlyDeposit}
      riskToleranceMod={riskToleranceMod}
    />
  );
};
